import { render, staticRenderFns } from "./Configuracao.vue?vue&type=template&id=c2fea480"
import script from "./Configuracao.vue?vue&type=script&lang=js"
export * from "./Configuracao.vue?vue&type=script&lang=js"
import style0 from "./Configuracao.vue?vue&type=style&index=0&id=c2fea480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports